import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=55f43f36&functional=true&"
var script = {}
import style0 from "./Separator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f43f36')) {
      api.createRecord('55f43f36', component.options)
    } else {
      api.rerender('55f43f36', component.options)
    }
    module.hot.accept("./Separator.vue?vue&type=template&id=55f43f36&functional=true&", function () {
      api.rerender('55f43f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Separator.vue"
export default component.exports